<div id="WitnessModalCalculator" class="modal is-touch is-short without-blur" [ngClass]="{'is-open': witnessItemModalOpenStatus}"
  (transitionend)="setDefaultFocus($event)">
  @if (witnessItemModalOpenStatus) {
    <div id="witnessModalCalcDiv" class="modal__content">
      <div class="modal__header pb0">
        <div class="flex align-center justify-content-between">
          <div class="h3">Verify QOH</div>
        </div>
      </div>
      <div class="modal__body">
        <div class="touch-table__table-wrapper has-tall-rows">
          <div class="flex flex-column col-8">
            <div class="touch-table p0 width100 verify-qoh-table-height">
              <div class="row no-gutters">
                <table id="witnessItemsTable" class="js-no-table-select" data-select-mode="single">
                  <thead>
                    <th class="left">
                      <div id="lblLocation">Location</div>
                      <div id="lblPosition">Position</div>
                    </th>
                    <th id="lblIconColumnHeader"> </th>
                    <th class="left col-7">
                      <div id="lblItemName">Item</div>
                    </th>
                    <th class="col-4">
                      <div id="lblQOHBeforeDispense" class="required-label">{{beforeAfterText}}</div>
                    </th>
                  </thead>
                  <tbody>
                    @for (item of sortedWitnessItems | paginate : pagingConfig; track trackItem(i, item); let i = $index) {
                      <tr id="witnessItem-{{i}}">
                        @if (shouldCreateRowSpan(i, item.groupIndex)) {
                          <td id="position-{{i}}" [attr.rowspan]="getRowspan(i, item.rowSpan, item.groupIndex)"
                            class="is-select-column drug-name--primary border-right border-gray-87 border-right border-gray-87 bg-gray-95">
                            <div class="drug-name--primary">{{item.doorName}}</div>
                            <div class="drug-name--alternate">{{item.positionName}}</div>
                            <div class="pill__wrapper">
                              @if (item.isBinItem) {
                                <div id="itemsCount-{{i}}" class="pill bg-maroon border-maroon h6 pl1">
                                  <svg>
                                    <use xlink:href="./assets/icons/connect-icons.svg#BIN"></use>
                                  </svg>
                                  {{item.itemsCount}} items
                                </div>
                              }
                            </div>
                          </td>
                        }
                        <td class="pl1">
                          <absg-icons [customId]="'witnessItemIcon'" [isAuditFavorite]="false" [iconProvider]="item" [suppressBinIcon]="true"
                            [isPreferred]="item.isPreferredNdc"></absg-icons>
                        </td>
                        <td class="col-7 left">
                          <div class="drug-name--primary truncate--single">
                            <div id="witnessItemDrugName-{{i}}">{{item.displayName}}</div>
                          </div>
                          <div class="flex is-inline align-center">
                            <div class="mr1 col-1 gray-40 h6">NDC</div>
                            <div class="bold gray-15 h5">{{item.ndc}}</div>
                          </div>
                          <div class="flex is-inline h6 gray-40">
                            @if ((item.lotNumber)) {
                              <div class="mr1 col-1 gray-40">Lot</div>
                            }
                            <div id="witnessItemLot-{{i}}" class="bold gray-15">{{item.lotNumber}}</div>
                          </div>
                          <absg-status-pills id="witnessVerfiyWitnessPill{{i}}" [customId]="i" [statusProvider]="item" [isWitness]="true"
                            [maxPillCountOnPage]="3" (showAllPills)="showAllPills($event)">
                          </absg-status-pills>
                        </td>
                        <td class="col-4 left">
                          <div class="form-group__text-mask-container">
                            <input #qohInput id="QOHInput-{{item.itemId}}-{{item.elementIdString}}" type="text"
                              class="form-control js-modal-trigger required pr0" (blur)="qohChange()" [(ngModel)]="item.userInputQtyInvUnitInCabinet"
                              ncFocus (onFocus)="onFocus($event)" (keyup)="onKeyUp($event)" (keydown)="onKeyDown($event)"
                              [disabled]="!(isQOHInputEnabled())">
                            <div class="form-group__text-mask pl1">{{item.inventoryUnitOfMeasure}}</div>
                          </div>
                        </td>
                      </tr>
                    }
                </table>
              </div>
            </div>
            <div class="flex align-center mt2">
              <div class="col-6">
                @if (isDoorUnLocked()) {
                  <div id="openDoorPlaceholder" class="h5 gray-67 italic mr4">
                    <label id="lblOpenDoorPlaceholder">Please open the door to continue.</label>
                  </div>
                }
              </div>
              <div class="col-6 flex justify-content-end">
                @if (ifPhysicalDoorAndNotSimulated()) {
                  <div class="h5 bold flex align-center ">
                    @if (isDoorLocked()) {
                      <svg class="fill-danger-core">
                        <use xlink:href='./assets/icons/connect-icons.svg#Lock'></use>
                      </svg>
                    }
                    @else {
                      <svg class="fill-success-dark">
                        <use xlink:href='./assets/icons/connect-icons.svg#Unlock'></use>
                      </svg>
                    }
                    <span [ngClass]="isDoorLocked() ? 'red' : 'success-dark'" id="doorStatus">{{doorStatusName}}</span>
                  </div>
                }
                <button id="verifyQOHReopen" class="btn btn--obsidian-31 ml3" [disabled]="isReopenDoorDisabled()"
                  [ngClass]="isReopenDoorDisabled() ? 'is-disabled': ''" (click)="onReopenDoorPositionClicked()">Reopen
                  Door @if (isSimulateModeOn()) {
                    <span class="red" id="doorBypassStatus">Bypass</span>
                  }</button>
              </div>
            </div>
          </div>
          <ul class="touch-pagination pl2">
            <div nc-pagination-controls [config]="pagingConfig"></div>
          </ul>
          <div class="modal__card-keypad">
            <div nc-keypad [isValidValueValidator]="scopedIsValidValue()"></div>
            <button id="qohConfirm" class="mt1 btn btn--true-blue col-12 js-modal-toggle" data-modal="WitnessModalCalculator"
              (click)="onConfirmButtonClicked()" [disabled]="!(qohChange())">Confirm</button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div id="verifyQOHPillComponentModal" nc-station-pill-component [pillItem]="displayPillItem" [isPillModalOpen]="isPillModalOpen"
  (closeModalEvent)="closeModalEvent($event)"></div>
